import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import ConfirmationPage from "./pages/ConfirmationPage";
import Dashboard from "./pages/Dashboard/Dashboard";
import LandingPage from "./pages/LandingPage/LandingPage";
import SendMoney from "./pages/SendMoney/SendMoney";
import PaymentTiers from "./pages/PaymentTiers/PaymentTiers";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import "./styles/app.css";
import "./../src/mediaQueries.css";
import "./styles/fonts.css";
import { useAppSelector } from "./store/hooks";
import { UserProps } from "./types/interface";
import SelectPaymentMethod from "./pages/SelectPaymentMethod/SelectPaymentMethod";
import Payment from "./pages/Payment/Payment";
import Confrim from "./pages/Confrim/Confirm";
import TransactionDetails from "./pages/TransactionDetails/TransactionDetails";
import Receivers from "./pages/Receiver/Receiver";
import AddReceivers from "./pages/Receiver/AddReceiver";
import EditReceivers from "./pages/Receiver/EditReceiver";
import TransactionSummary from "./pages/TransactionSummary/TransactionSummary";
import Tracker from "./pages/Tracker";
import StickyNavBar from "./components/StickyNavBar";
import TermsOfService from "./pages/TermsOfService.tsx/TermsOfService";
import Investors from "./pages/Investors/Investors";
import MortgageChainLanding from "./pages/MortgageChainLanding/MortgageChainLanding";
import MortgageChainAPIDocs from "./pages/MortgageChainAPIDocs/MortgageChainAPIDocs";
import MortgageChainPrivacyPolicy from "./pages/MortgageChainPrivacyPolicy/MortgageChainPrivacyPolicy";
import MortgageChainTermsOfService from "./pages/MortgageChainTermsOfService/MortgageChainTermsOfService";
import MortgageChainRiskDisclosures from "./pages/MortgageChainRiskDisclosures/MortgageChainRiskDisclosures";
import PitchDeck from "./pages/PitchDeck/PitchDeck";
import MortgageChainDashboard from "./pages/MortgageChainDashboard/MortgageChainDashboard";
import QueryBuilder from "./pages/MortgageChainDashboard/QueryBuilder";
import BlockchainVerification from "./pages/MortgageChainDashboard/BlockchainVerification";
import PartnerPortal from "./pages/MortgageChainDashboard/PartnerPortal";
import APIPlayground from "./pages/MortgageChainDashboard/APIPlayground";
import RouteSEO from "./seo/RouteSEO";
import MarketAnalysis from "./pages/MarketAnalysis";

function AppContent() {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";

  return (
    <>
      {!isDashboard && <StickyNavBar />}
      <RouteSEO />
      <Routes>
        {/* MortgageChain Routes - Main Domain */}
        <Route path="/" element={<MortgageChainLanding />} />
        <Route path="/mortgagechain" element={<MortgageChainLanding />} />
        <Route path="/docs" element={<MortgageChainAPIDocs />} />
        <Route path="/mortgagechain/docs" element={<MortgageChainAPIDocs />} />
        <Route
          path="/privacy-policy"
          element={<MortgageChainPrivacyPolicy />}
        />
        <Route
          path="/mortgagechain/privacy-policy"
          element={<MortgageChainPrivacyPolicy />}
        />
        <Route
          path="/terms-of-service"
          element={<MortgageChainTermsOfService />}
        />
        <Route
          path="/mortgagechain/terms-of-service"
          element={<MortgageChainTermsOfService />}
        />
        <Route
          path="/risk-disclosures"
          element={<MortgageChainRiskDisclosures />}
        />
        <Route
          path="/mortgagechain/risk-disclosures"
          element={<MortgageChainRiskDisclosures />}
        />

        {/* Pitch Deck Route */}
        <Route path="/pitch-deck" element={<PitchDeck />} />

        {/* Market Analysis */}
        <Route path="/stocks" element={<MarketAnalysis />} />

        {/* MortgageChain Dashboard Routes */}
        <Route path="/dashboard" element={<MortgageChainDashboard />} />
        {/* <Route
          path="/mortgagechain/dashboard"
          element={<MortgageChainDashboard />}
        />
        <Route path="/dashboard/query-builder" element={<QueryBuilder />} />
        <Route
          path="/mortgagechain/dashboard/query-builder"
          element={<QueryBuilder />}
        />
        <Route
          path="/dashboard/blockchain"
          element={<BlockchainVerification />}
        />
        <Route
          path="/mortgagechain/dashboard/blockchain"
          element={<BlockchainVerification />}
        />
        <Route path="/dashboard/partner" element={<PartnerPortal />} />
        <Route
          path="/mortgagechain/dashboard/partner"
          element={<PartnerPortal />}
        />
        <Route path="/dashboard/api" element={<APIPlayground />} />
        <Route
          path="/mortgagechain/dashboard/api"
          element={<APIPlayground />}
        /> */}

        {/* Old Routes - Commented Out */}
        {/* <Route
          path="/*"
          element={isLoggedIn ? <Navigate to="/dashboard" /> : <LandingPage />}
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/:id"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/send/"
          element={
            // <ProtectedRoute isLoggedIn={isLoggedIn}>
            <SendMoney user={user as UserProps} />
            // </ProtectedRoute>
          }
        />

        <Route path="/recipient/add/" element={<AddReceivers />} />
        <Route path="/recipient/edit/:id" element={<EditReceivers />} />
        <Route
          path="/payment/:id"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <Payment user={user as UserProps} />
            </ProtectedRoute>
          }
        />

        <Route path="/payment-tiers" element={<PaymentTiers />} />
        <Route path="/send/details" element={<TransactionDetails />} />
        <Route path="/send/details/receiver/add" element={<AddReceivers />} />
        <Route path="/send/add/recipient/" element={<AddReceivers />} />

        <Route path="/recipient/edit/:id" element={<EditReceivers />} />
        <Route
          path="/send/details/transaction"
          element={<TransactionSummary />}
        />

        <Route path="/tracker" element={<Tracker />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/investors" element={<Investors />} /> */}

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

function App() {
  // const { isLoggedIn, user } = useAppSelector((state) => state.auth);

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

const ProtectedRoute: React.FC<{
  isLoggedIn: boolean;
  children: JSX.Element;
}> = ({ isLoggedIn, children }) => {
  return isLoggedIn ? children : <Navigate to="/" />;
};

export default App;
